export default function LoadingState({ label = "Loading experience..." }: { label?: string }) {
  return (
    <div className="surface-card flex min-h-[240px] items-center justify-center px-6 text-center">
      <div>
        <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-4 border-[var(--pp-gold)] border-t-transparent" />
        <p className="text-sm font-semibold text-muted-foreground">{label}</p>
      </div>
    </div>
  );
}
